import { useEffect } from "react";

import { HeaderWithNextButtonLayout } from "@components";
import {
  Children,
  Parent,
  PermanentAddress,
  PresentAddress,
  Spouses,
  Ration,
} from "./components";

import { useFamilyInfo } from "@hooks/HRM/employee/useFamilyInfo";
import { useGeneralInfo } from "@hooks/HRM/employee/useGeneralInfo";

export interface FamilyInfoPropsType {
  id: number | null;
  changeActiveTab: (arg: number) => void;
  setIsSuccessModalOpen: (arg: boolean) => void;
  setIsErrorModalOpen: (arg: boolean) => void;
  isProfileDisabled: boolean;
  canCreateEmployee: boolean;
  canEditEmployee: boolean;
}

function FamilyInfo({
  id,
  changeActiveTab,
  setIsErrorModalOpen,
  setIsSuccessModalOpen,
  isProfileDisabled,
  canCreateEmployee,
  canEditEmployee,
}: FamilyInfoPropsType) {
  const {
    familyInfo,

    changeParentInfo,
    changeSpouseInfo,
    changeChildrenInfo,
    changePermanentAddressInfo,
    changePresentAddressInfo,

    removeChildInfo,
    removeSpouseInfo,

    getFamilyInfoRequestOngoing,

    updateParentRequestOngoing,
    updateParentSuccess,
    updateParentFailed,

    updateSpouseRequestOngoing,
    updateSpouseSuccess,
    updateSpouseFailed,

    updatePermanentAddressRequestOngoing,
    updatePermanentAddressSuccess,
    updatePermanentAddressFailed,

    updatePresentAddressRequestOngoing,
    updatePresentAddressSuccess,
    updatePresentAddressFailed,

    updateChildRequestOngoing,
    updateChildSuccess,
    updateChildFailed,

    deleteChildRequestOngoing,
    deleteChildSuccess,
    deleteChildFailed,

    deleteSpouseRequestOngoing,
    deleteSpouseSuccess,
    deleteSpouseFailed,

    ration,
    refetchRationData,
  } = useFamilyInfo(id);
  const { generalInfo } = useGeneralInfo(id);
  const { maritalStatusId } = generalInfo || {};

  const {
    parents,
    spouse,
    children,
    employeePermanentAddresses,
    employeePresentAddresses,
  } = familyInfo || {};

  useEffect(() => {
    setIsSuccessModalOpen(
      updateParentSuccess ||
        updateSpouseSuccess ||
        updatePermanentAddressSuccess ||
        updatePresentAddressSuccess ||
        updateChildSuccess ||
        deleteChildSuccess ||
        deleteSpouseSuccess,
    );
    setIsErrorModalOpen(
      updateParentFailed ||
        updateSpouseFailed ||
        updatePermanentAddressFailed ||
        updatePresentAddressFailed ||
        updateChildFailed ||
        deleteChildFailed ||
        deleteSpouseFailed,
    );
  }, [
    updateParentSuccess,
    updateSpouseSuccess,
    deleteSpouseSuccess,
    updatePermanentAddressSuccess,
    updatePresentAddressSuccess,
    updateChildSuccess,
    deleteChildSuccess,
    updateParentFailed,
    updateSpouseFailed,
    updatePermanentAddressFailed,
    updatePresentAddressFailed,
    updateChildFailed,
    deleteChildFailed,
    deleteSpouseFailed,
  ]);

  return (
    <HeaderWithNextButtonLayout
      title="EMPLOYEE.FAMILY_INFO.HEADING"
      subtitle="EMPLOYEE.FAMILY_INFO.DESCRIPTION"
      action={() => changeActiveTab(3)}
    >
      <Parent
        parentInfo={parents}
        changeParentInfo={changeParentInfo}
        getFamilyInfoRequestOngoing={getFamilyInfoRequestOngoing}
        updateParentRequestOngoing={updateParentRequestOngoing}
        isProfileDisabled={isProfileDisabled}
        canCreateEmployee={canCreateEmployee}
        canEditEmployee={canEditEmployee}
      />

      {/* only if the employee is married then let him/her add spouse info */}
      {maritalStatusId === 14 || maritalStatusId === 15 ? (
        <Spouses
          spouseInfo={spouse}
          changeSpouseInfo={changeSpouseInfo}
          removeSpouseInfo={removeSpouseInfo}
          getFamilyInfoRequestOngoing={getFamilyInfoRequestOngoing}
          updateSpouseRequestOngoing={updateSpouseRequestOngoing}
          deleteSpouseRequestOngoing={deleteSpouseRequestOngoing}
          isProfileDisabled={isProfileDisabled}
          canCreateEmployee={canCreateEmployee}
          canEditEmployee={canEditEmployee}
        />
      ) : null}
      <Children
        childrenInfo={children}
        changeChildrenInfo={changeChildrenInfo}
        removeChildInfo={removeChildInfo}
        getFamilyInfoRequestOngoing={getFamilyInfoRequestOngoing}
        updateChildRequestOngoing={updateChildRequestOngoing}
        deleteChildRequestOngoing={deleteChildRequestOngoing}
        isProfileDisabled={isProfileDisabled}
        canCreateEmployee={canCreateEmployee}
        canEditEmployee={canEditEmployee}
      />
      <Ration
        rationInfo={ration}
        refetchRationData={refetchRationData}
        employeeMasterId={id}
        getFamilyInfoRequestOngoing={getFamilyInfoRequestOngoing}
        updateRationRequestOngoing={updatePermanentAddressRequestOngoing}
        isProfileDisabled={isProfileDisabled}
        setIsErrorModalOpen={setIsErrorModalOpen}
        setIsSuccessModalOpen={setIsSuccessModalOpen}
      />
      <PermanentAddress
        permanentAddressInfo={employeePermanentAddresses}
        changePermanentAddressInfo={changePermanentAddressInfo}
        getFamilyInfoRequestOngoing={getFamilyInfoRequestOngoing}
        updatePermanentAddressRequestOngoing={
          updatePermanentAddressRequestOngoing
        }
        isProfileDisabled={isProfileDisabled}
        canCreateEmployee={canCreateEmployee}
        canEditEmployee={canEditEmployee}
      />
      <PresentAddress
        presentAddressInfo={employeePresentAddresses}
        changePresentAddressInfo={changePresentAddressInfo}
        getFamilyInfoRequestOngoing={getFamilyInfoRequestOngoing}
        updatePresentAddressRequestOngoing={updatePresentAddressRequestOngoing}
        isProfileDisabled={isProfileDisabled}
        canCreateEmployee={canCreateEmployee}
        canEditEmployee={canEditEmployee}
      />
    </HeaderWithNextButtonLayout>
  );
}

export default FamilyInfo;
